// File#: _1_faq-page.js
(function () {

    var faqPage = document.getElementsByClassName('faq-page')[0];
    if (faqPage) {
        var nav = faqPage.getElementsByTagName('aside')[0];
        var links = nav.getElementsByTagName('a');
        var headerOffset = 180;

        for (var i = 0; i < links.length; i++) {

            links[i].addEventListener('click', function (e) {
                e.preventDefault();
                var targetId = this.getAttribute('href').slice(1);
                var targetEl = document.getElementById(targetId);
                var targetPos = targetEl.getBoundingClientRect().top + window.pageYOffset - headerOffset;

                Helper.ScrollTo(targetPos, 500);
            });
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        const buttons = document.querySelectorAll('.accordion__header');

        buttons.forEach(button => {
            button.addEventListener('click', function () {

                const addIcon = button.querySelector('.add-icon');
                const arrowIconContainer = button.querySelector('.arrow-icon-container');
                const arrowIcon = arrowIconContainer.querySelector('.arrow-up-icon');

                addIcon.classList.toggle('hidden');
                arrowIcon.classList.toggle('hidden');
            });
        });
    });

})();